  <template>
  <div
    :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']"
    ref="box"
    v-if="webshow"
  >
    <navReturn></navReturn>
    <product-con-swiper :img-urls="storeInfo.slider_image"></product-con-swiper>
    <div class="wrapper" >
      <div class="share acea-row row-between row-bottom">
        <div class="money">
          <span class="num">₱1</span>
        </div>
        <!--<div class="iconfont icon-fenxiang" @click="listenerActionSheet"></div>-->
      </div>
      <div class="introduce">{{ storeInfo.name }}</div>

      <div class="progress" >
        <div class="row">
          <div>Total:{{storeInfo.now_game.total}}</div>
          <div>Residue:{{storeInfo.now_game.total - storeInfo.now_game.num>=0?storeInfo.now_game.total - storeInfo.now_game.num:0}}</div>
          <div>progress:{{((storeInfo.now_game.num/storeInfo.now_game.total)*100).toFixed(2)+'%'}}</div>
        </div>
        <div class="bar">
          <div class="mind" :style="{width:((storeInfo.now_game.num/storeInfo.now_game.total)*100)+'%'}"></div>
        </div>
        <div class="row" style="margin-top: 10px" v-if="storeInfo.now_game.total - storeInfo.now_game.num==0">
          <CountdownGame tipText="Next time start:" :datatime="storeInfo.next_time_stamp + 10"></CountdownGame>
        </div>
        <div class="row" style="margin-top: 10px" v-if="storeInfo.now_game.total - storeInfo.now_game.num==0">
          <div>Winner: {{storeInfo.now_game.award_user.nickname || 'In the calculation...'}}</div>
          <div v-if="storeInfo.now_game.award_user.level">Winner level: {{storeInfo.now_game.award_user.level}}</div>
        </div>

      </div>

    </div>
    <div class="attribute acea-row row-between-wrapper" @click="selecAttrTap">
      <div>
        {{ attrTxt }}:<span class="atterTxt">{{ attrValue }}</span>
      </div>
      <div class="iconfont icon-jiantou"></div>
    </div>

    <scrollText :list="awardList"></scrollText>


    <div class="product-intro" v-if="storeInfo.content!==null">
      <div class="title">Product description</div>
      <div class="conter v-html" v-html="storeInfo.content"></div>
    </div>
    <div style="height:1.2rem;"></div>
    <div class="footer acea-row row-between-wrapper">
      <div class="item" @click="$router.push({ path: '/' })">
        <div class="iconfont icon-shouye-xianxing"></div>
        <div>Home</div>
      </div>
      <!-- <div class="item" @click="$router.push({ path: '/customer/list' })">
        <div class="iconfont icon-kefu"></div>
        <div>客服</div>
      </div> -->
      <!--<div class="item" @click="setCollect">-->
        <!--<div-->
          <!--class="iconfont"-->
          <!--:class="storeInfo.userCollect ? 'icon-shoucang1' : 'icon-shoucang'"-->
        <!--&gt;</div>-->
        <!--<div>收藏</div>-->
      <!--</div>-->

      <!-- <router-link
        :to="'/cart'"
        class="item animated"
        :class="animated === true ? 'bounceIn' : ''"
      >
        <div class="iconfont icon-gouwuche1">
          <span class="num bg-color-red" v-if="CartCount > 0">{{
            CartCount
          }}</span>
        </div>
        <div>购物车</div>
      </router-link> -->
      <div class="bnt acea-row">
        <!-- <div class="joinCart" @click="joinCart">加入购物车</div> -->
        <div class="buy" @click="tapBuy">Check Out</div>
      </div>
    </div>
    <RaidersGoodsWindow v-on:changeFun="changeFun" :attr="storeInfo"></RaidersGoodsWindow>


  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import ProductConSwiper from "@components/ProductConSwiper";
import scrollText from "@components/scrollText";
import navReturn from "@components/navReturn";
import UserEvaluation from "@components/UserEvaluation";
import ShareRedPackets from "@components/ShareRedPackets";
import CouponPop from "@components/CouponPop";
import RaidersGoodsWindow from "@components/RaidersGoodsWindow";
import StorePoster from "@components/StorePoster";
import ShareInfo from "@components/ShareInfo";
import CountdownGame from "@components/CountdownGame";

import { getList,getAward } from "@api/raiders";


import {
  getCartCount,
  getProductCode
} from "@api/store";
import {
  getCoupon,
  getCollectAdd,
  getCollectDel,
  getUserInfo
} from "@api/user";
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
import { imageBase64 } from "@api/public";
import { mapGetters } from "vuex";
let NAME = "detail";
export default {
  name: NAME,
  components: {
    navReturn,
    CountdownGame,
    scrollText,
    swiper,
    swiperSlide,
    ProductConSwiper,
    UserEvaluation,
    ShareRedPackets,
    CouponPop,
    RaidersGoodsWindow,
    StorePoster,
    ShareInfo
  },
  data: function() {
    return {
      webshow:false,
      awardList:[],
      nextTime:'',
      shareInfoStatus: false,
      weixinStatus: false,
      mapShow: false,
      mapKey: "",
      posterData: {
        image: "",
        title: "",
        price: "",
        code: ""
      },
      posterImageStatus: false,
      animated: false,
      coupon: {
        coupon: false,
        list: []
      },
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {}
      },
      isOpen: false, //是否打开属性组件
      productValue: [],
      id: 0,
      storeInfo: {},
      couponList: [],
      attrTxt: "Please select",
      attrValue: "",
      cart_num: 1, //购买数量
      replyCount: "",
      replyChance: "",
      reply: [],
      priceName: 0,
      CartCount: 0,
      posters: false,
      banner: [{}, {}],
      swiperRecommend: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: false,
        loop: false,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      goodList: [],
      system_store: {},
      qqmapsdk: null
    };
  },
  computed: mapGetters(["isLogin"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.id = n.params.id;

        this.productCon();
      }
    }
  },
  updated() {
    window.scroll(0, 0);
  },
  mounted: function() {
    this.id = this.$route.params.id;
    this.productCon();
    // this.coupons();
  },
  methods: {
    autoRefresh(){
      location.reload()
    },
    showChang: function() {
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.system_store.latitude),
          longitude: parseFloat(this.system_store.longitude),
          name: this.system_store.name,
          address: this.system_store._detailed_address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            // console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "Map currently unavailable"
          );
        this.mapShow = true;
      }
    },
    updateTitle() {
      document.title = this.storeInfo.name || this.$route.meta.title;
    },
    setOpenShare: function() {
      var data = this.storeInfo;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then(res => {
            href =
              href.indexOf("?") === -1
                ? href + "?spread=" + res.data.uid
                : href + "&spread=" + res.data.uid;
            var configAppMessage = {
              desc: data.store_info,
              title: data.store_name,
              link: href,
              imgUrl: data.image
            };
            wechatEvevt(
              ["updateAppMessageShareData", "updateTimelineShareData"],
              configAppMessage
            )
              .then(res => {
                // console.log(res);
              })
              .catch(res => {
                // console.log(res);
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                }
              });
          });
        } else {
          var configAppMessage = {
            desc: data.store_info,
            title: data.store_name,
            link: href,
            imgUrl: data.image
          };
          wechatEvevt(
            ["updateAppMessageShareData", "updateTimelineShareData"],
            configAppMessage
          )
            .then(res => {
              // console.log(res);
            })
            .catch(res => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
              }
            });
        }
      }
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
    },
    shareCode: function(value) {
      var that = this;
      getProductCode(that.id).then(res => {
        if (res.data.code) that.posterData.code = res.data.code;
        value === false && that.listenerActionSheet();
      });
    },
    setPosterImageStatus: function() {
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.posterImageStatus = !this.posterImageStatus;
      this.posters = false;
    },
    //产品详情接口；
    productCon: function() {
      let that = this;
      this.$dialog.loading.open('loading...')
      getList({id:that.id})
        .then(res => {
          // if (res.data.name.length > 30) {
          //   res.data.name = res.data.name.substring(0, 30) + "...";
          // }
          let list = res.data[0]
          list.cartAttr = false
          list.cart_num = 1
          list.stock = res.data[0].now_game.total -  res.data[0].now_game.num
          list.next_time_stamp = res.data[0].next_issue_time

          this.storeInfo = list
          this.webshow = true
          this.$dialog.loading.close()


          // that.$set(that, "storeInfo", res.data.storeInfo);
          // that.$set(that.attr, "productAttr", res.data);
          // that.$set(that, "productValue", res.data.productValue);
          // that.$set(that, "replyCount", res.data.replyCount);
          // that.$set(that, "replyChance", res.data.replyChance);
          // that.reply = res.data.reply ? [res.data.reply] : [];
          // that.$set(that, "reply", that.reply);
          // that.$set(that, "priceName", res.data.name);
          // that.posterData.image = that.storeInfo.image_base;
          //
          // that.posterData.price = that.storeInfo.price;
          // that.posterData.code = that.storeInfo.code_base;
          // that.system_store = res.data.system_store;
          // let good_list = res.data.good_list || [];
          // let goodArray = [];
          // let count = Math.ceil(good_list.length / 6);
          // for (let i = 0; i < count; i++) {
          //   var list = good_list.slice(i * 6, 6);
          //   if (list.length) goodArray.push({ list: list });
          // }
          // that.mapKey = res.data.mapKey;
          // that.$set(that, "goodList", goodArray);
          that.updateTitle();
          // that.getCartCount();
          // that.getImageBase64();
          // that.setOpenShare();
        })
        .catch(res => {
          this.$dialog.loading.close()
          console.log('error',res)

          that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
      getAward({id:that.id}).then(res=>{
        this.awardList = res.data
      })
    },
    getImageBase64: function() {
      let that = this;
      imageBase64(this.posterData.image, that.posterData.code)
        .then(res => {
          that.posterData.image = res.data.image;
          that.posterData.code = res.data.code;
          that.isLogin && that.shareCode();
        })
        .catch(() => {
          that.isLogin && that.shareCode();
        });
    },
    //购物车；
    ChangeCartNum: function(changeValue) {

      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length)
        productSelect = this.attr.productSelect;



      //无属性值即库存为0；不存在加减；
      let stock = this.storeInfo.stock || 0;
      let num = this.storeInfo;
      console.log('changeValue',changeValue)
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > stock) {
          this.$set(this.storeInfo, "cart_num", stock);
        }else {
          this.$set(this.storeInfo, "cart_num", num.cart_num);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.storeInfo, "cart_num", 1);
        }else {
          this.$set(this.storeInfo, "cart_num", num.cart_num);
        }

      }
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function(opt) {
      // console.log(opt)
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    //打开优惠券插件；
    couponTap: function() {
      let that = this;
      that.coupons();
      that.coupon.coupon = true;
    },
    changecoupon: function(msg) {
      this.coupon.coupon = msg;
      this.coupons();
    },
    currentcoupon: function(res) {
      let that = this;
      that.coupon.coupon = false;
      that.$set(that.coupon.list[res], "is_use", true);
    },
    //可领取优惠券接口；
    // coupons: function() {
    //   let that = this,
    //     q = { page: 1, limit: 20 };
    //   getCoupon(q).then(res => {
    //     that.$set(that, "couponList", res.data || []);
    //     that.$set(that.coupon, "list", res.data);
    //   });
    // },
    //打开属性插件；
    selecAttrTap: function() {
      this.storeInfo.cartAttr = true;
      this.isOpen = true;
    },
    changeattr: function(msg) {
      this.storeInfo.cartAttr = msg;
      this.isOpen = false;
    },

    //收藏商品
    setCollect: function() {
      let that = this,
        id = that.storeInfo.id,
        category = "product";
      if (that.storeInfo.userCollect) {
        getCollectDel(id, category).then(function() {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      } else {
        getCollectAdd(id, category).then(function() {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      }
    },
    goGoods(val) {
      // return this.$router.push({ path: "/detail/" + val.id });
    },
    //  点击加入购物车按钮
    joinCart: function() {
      //0=加入购物车
      this.goCat(0);
    },
    // 加入购物车；
    goCat: function() {

      let that = this,
        productSelect = that.storeInfo;


      //打开属性
      if (that.attrValue) {
        //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
        that.storeInfo.cartAttr = !that.isOpen ? true : false;
      } else {
        if (that.isOpen) that.storeInfo.cartAttr = true;
        else that.storeInfo.cartAttr = !that.storeInfo.cartAttr;
      }
      //只有关闭属性弹窗时进行加入购物车
      if (that.storeInfo.cartAttr === true && that.isOpen === false)
        return (that.isOpen = true);
      //如果有属性,没有选择,提示用户选择
      if(that.storeInfo.cart_num>that.storeInfo.stock){
        return that.$dialog.toast({ mes: "Inventory less than "+that.storeInfo.cart_num });
      }

        that.$router.push({ path: "/raiders/submit/"+this.storeInfo.id+"/"+this.storeInfo.cart_num});
    },

    //立即购买；
    tapBuy: function() {
      //  1=直接购买
      if(this.storeInfo.stock<1){
        return this.$dialog.error('Insufficient inventory!')
      }
      this.goCat(1);
    },
    listenerActionSheet: function() {
      if (isWeixin() === true) {
        this.weixinStatus = true;
      }
      this.posters = true;
    },
    listenerActionClose: function() {
      this.posters = false;
    }
  }
};
</script>
  <style scoped>
    .geoPage {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      z-index: 10000;
    }
    .product-con .wrapper{
      padding-bottom: 20px;
    }
    .product-con .store-info {
      margin-top: 0.2rem;
      background-color: #fff;
    }
    .product-con .store-info .title {
      padding: 0 0.3rem;
      font-size: 0.28rem;
      color: #282828;
      height: 0.8rem;
      line-height: 0.8rem;
      border-bottom: 0.01rem solid #f5f5f5;
    }
    .product-con .store-info .info {
      padding: 0 0.3rem;
      height: 1.26rem;
    }
    .product-con .store-info .info .picTxt {
      width: 6.15rem;
    }
    .product-con .store-info .info .picTxt .pictrue {
      width: 0.76rem;
      height: 0.76rem;
    }
    .product-con .store-info .info .picTxt .pictrue img {
      width: 100%;
      height: 100%;
      border-radius: 0.06rem;
    }
    .product-con .store-info .info .picTxt .text {
      width: 5.22rem;
    }
    .product-con .store-info .info .picTxt .text .name {
      font-size: 0.3rem;
      color: #282828;
    }
    .product-con .store-info .info .picTxt .text .address {
      font-size: 0.24rem;
      color: #666;
      margin-top: 0.03rem;
    }
    .product-con .store-info .info .picTxt .text .address .iconfont {
      color: #707070;
      font-size: 0.18rem;
      margin-left: 0.1rem;
    }
    .product-con .store-info .info .picTxt .text .address .addressTxt {
      max-width: 4.8rem;
      width: auto;
    }
    .product-con .store-info .info .iconfont {
      font-size: 0.4rem;
    }
    .product-con .superior {
      background-color: #fff;
      margin-top: 0.2rem;
    }
    .product-con .superior .title {
      height: 0.98rem;
    }
    .product-con .superior .title img {
      width: 0.3rem;
      height: 0.3rem;
    }
    .product-con .superior .title .titleTxt {
      margin: 0 0.2rem;
      font-size: 0.3rem;
      background-image: linear-gradient(to right, #f57a37 0%, #f21b07 100%);
      background-image: -webkit-linear-gradient(to right, #f57a37 0%, #f21b07 100%);
      background-image: -moz-linear-gradient(to right, #f57a37 0%, #f21b07 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .product-con .superior .slider-banner {
      width: 6.9rem;
      margin: 0 auto;
      padding-bottom: 0.2rem;
    }
    .product-con .superior .slider-banner .list {
      width: 100%;
      padding-bottom: 0.2rem;
    }
    .product-con .superior .slider-banner .list .item {
      width: 2.15rem;
      margin: 0 0.22rem 0.3rem 0;
      font-size: 0.26rem;
    }
    .product-con .superior .slider-banner .list .item:nth-of-type(3n) {
      margin-right: 0;
    }
    .product-con .superior .slider-banner .list .item .pictrue {
      width: 100%;
      height: 2.15rem;
    }
    .product-con .superior .slider-banner .list .item .pictrue img {
      width: 100%;
      height: 100%;
      border-radius: 0.06rem;
    }
    .product-con .superior .slider-banner .list .item .name {
      color: #282828;
      margin-top: 0.12rem;
    }
    .product-con .superior .slider-banner .swiper-pagination-bullet {
      background-color: #999;
    }
    .product-con .superior .slider-banner .swiper-pagination-bullet-active {
      background-color: #e93323;
    }

    .mask {
      -webkit-filter: blur(2px);
      -moz-filter: blur(2px);
      -ms-filter: blur(2px);
      filter: blur(2px);
    }
    .footer .icon-shoucang1 {
      color: #e93323;
    }
    .product-con .product-intro .conter div {
      width: 100% !important;
    }

    .generate-posters {
      width: 100%;
      height: 1.7rem;
      background-color: #fff;
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 99;
      transform: translate3d(0, 100%, 0);
      -webkit-transform: translate3d(0, 100%, 0);
      -ms-transform: translate3d(0, 100%, 0);
      -moz-transform: translate3d(0, 100%, 0);
      -o-transform: translate3d(0, 100%, 0);
      transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
      -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
      -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
      -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    }
    .generate-posters.on {
      transform: translate3d(0, 0, 0);
      -webkit-transform: translate3d(0, 0, 0);
      -ms-transform: translate3d(0, 0, 0);
      -moz-transform: translate3d(0, 0, 0);
      -o-transform: translate3d(0, 0, 0);
    }
    .generate-posters .item {
      flex: 50%;
      -webkit-flex: 50%;
      -ms-flex: 50%;
      text-align: center;
    }
    .generate-posters .item .iconfont {
      font-size: 0.8rem;
      color: #5eae72;
    }
    .generate-posters .item .iconfont.icon-haibao {
      color: #5391f1;
    }
    .noscroll {
      height: 100%;
      overflow: hidden;
    }
    .progress{
      width: 100%;
      font-size: 0.25rem;
      padding: 0 0.27rem;
      box-sizing: border-box;
      margin-top: 0.2rem;

    }
    .onProgress{
      position: absolute;
      bottom: 0.22rem;
      left: 0.22rem;
    }
    .progress .row{
      display: flex;
      justify-content: space-between;
    }
    .progress .bar{
      width: 100%;
      height:10px;
      border-radius: 15px;
      background: #F3F3F3;
    }
    .progress .bar .mind{
      width: 0%;
      height: 10px;
      border-radius: 15px;
      background: #FFB903;
    }

  </style>
